import * as React from "react";
import { IExplorerProperties, IDataEntityResponse, IColumnMap } from "../../models";
import { ExplorerTabContent } from '../ExplorerTabContent';
import { WatchlistButton } from '../WatchlistButton';
import { Disclaimer } from "../../assets/";
import { BackToTop } from "../../assets/BackToTop/BackToTop";
import { FundExplorerFooter } from "./";
import { safe, removeKeyWhenFalse, filterColumnsCSV, isPrint } from "../../utils";

const FaPDF = require('react-icons/lib/fa/file-pdf-o');
const FaAngleRight = require('react-icons/lib/fa/angle-right');
const styles = require('../FundPages/Fundpages.pcss');
const tabStyles = require('./FundExplorerTabs.pcss');
const backToTopstyles = require('./overrides/BackToTopoverride.pcss');
const portfolioCostsOverride = require('./overrides/PortfolioCostsOverride.pcss');

interface IProps {
    groupedRows: any[];
}

export class ExplorerTabCharges extends React.Component<IProps & IExplorerProperties, {}>{

    constructor(props) {
        super(props)
    }

    getColumns(isPPL, csvDownload = false) {
        let { appParams, editWatchlist, watchlist, disclaimers } = this.props;
        let { productrange, region } = appParams;
        let tooltipDefault = false;

        const hideFundName = true;
        const hideShareClass = isPPL;
        const hideCurrency = isPPL;

        let columns: IColumnMap[] = [
            {
                headerKey: 'Fund Name',
                field: 'display',
                entity: "fund",
                type: 'string',
                headerRowSpan: 1,
                isCSV: true,
                viewRestriction: 'table',
                explicitHide: hideFundName,
                headerClassName: tabStyles.fundNameColumn,
                className: tabStyles.fundNameRow
            },
            {
                headerKey: 'Share Class',
                field: 'properties.shareclass_display',
                type: 'string',
                viewRestriction: 'table',
                tooltip: safe(() => disclaimers["TODO"][0]["disclaimers"][0], tooltipDefault),
                headerRowSpan: 1,
                isCSV: true,
                explicitHide: hideShareClass,
                headerClassName: tabStyles.columnLeft,
                className: tabStyles.firstColumn
            },
            {
                headerKey: 'Currency',
                field: 'properties.shareclass_currency_code',
                tooltip: safe(() => disclaimers["TODO"][0]["disclaimers"][0], tooltipDefault),
                headerRowSpan: 1,
                isCSV: true,
                explicitHide: hideCurrency,
                type: 'string'
            },
            {
                headerKey: 'As at date',
                field: 'latestTimeseriesValues.charges.date',
                type: 'date',
                headerRowSpan: 1,
                isCSV: true,
                headerClassName: tabStyles.dateColumn
            },
            {
                headerKey: 'Entry charge (%)',
                field: 'latestTimeseriesValues.charges.entry_charge',
                type: 'number',
                precision: 2,
                emptyPlaceholder: "0.00",
                isCSV: true,
                tooltip: safe(() => disclaimers["tooltip_entry_charge"][0]["disclaimers"][0], tooltipDefault),
                headerRowSpan: 1,
                headerClassName: tabStyles.columnRight,
                className: tabStyles.numberColumn
            },
            {
                headerKey: 'Ongoing charge (%)',
                field: 'latestTimeseriesValues.charges.total_ongoing_charges',
                type: 'number',
                precision: 2,
                emptyPlaceholder: "0.00",
                isCSV: true,
                checkEstimateActualNotAvailable: true,
                tooltip: safe(() => disclaimers["tooltip_ongoing_charge"][0]["disclaimers"][0], tooltipDefault),
                headerRowSpan: 1,
                headerClassName: tabStyles.columnRight,
                className: tabStyles.numberColumn
            },
            {
                headerKey: 'Exit charge (%)',
                field: 'latestTimeseriesValues.charges.exit_charge',
                type: 'number',
                precision: 2,
                emptyPlaceholder: "0.00",
                isCSV: true,
                tooltip: safe(() => disclaimers["tooltip_exit_charge"][0]["disclaimers"][0], tooltipDefault),
                headerRowSpan: 1,
                headerClassName: tabStyles.columnRight,
                className: tabStyles.numberColumn
            },
            // {
            //     headerKey: 'Portfolio transaction costs',
            //     field: 'latestTimeseriesValues.charges.direct_portfolio_costs',
            //     type: 'string',
            //     tooltip: safe(() => disclaimers["tooltip_direct_portfolio_costs"][0]["disclaimers"][0], tooltipDefault),
            //     headerColSpan: 2,
            //     paddingLeft: 38,
            //     isParentHeader: true,
            //     explicitHide: true,
            //     viewRestriction: 'card',
            //     headerClassName: tabStyles.minorRow
            // },

            // SB-6591 requested that we hide a number of columns.  Including to hide both Direct and Indirect transaction costs.  These 2 needs to be consolidated into 
            // one column that uses the direct cost data point, renamed to to "Profolio transaction costs", and include the tooltip

            //  All coluns to be hidden have been commented out, and below is a copy of the original Direct % column config as well as the renamed one.

            // {
            //     headerKey: 'Direct (%)',
            //     field: 'latestTimeseriesValues.charges.direct_portfolio_costs',
            //     type: 'number',
            //     precision: 2,
            //     emptyPlaceholder: "0.00",
            //     isCSV: true,
            //     tooltip: safe(() => disclaimers["tooltip_direct_portfolio_transaction_costs"][0]["disclaimers"][0], tooltipDefault),
            //     className: tabStyles.numberColumn,
            //     headerRowSpan: 1,
            //     headerClassName: tabStyles.columnRight
            // },
            {
                headerKey: 'Portfolio transaction costs (%)',
                field: 'latestTimeseriesValues.charges.total_portfolio_trx_costs',
                type: 'number',
                precision: 2,
                emptyPlaceholder: "0.00",
                isCSV: true,
                tooltip: safe(() => disclaimers["tooltip_portfolio_transaction_costs"][0]["disclaimers"][0], tooltipDefault),
                className: tabStyles.numberColumn,
                //headerRowSpan: 1,
                //headerClassName: portfolioCostsOverride.portfolioCosts,
                headerClassName: tabStyles.columnRight,
                headerColSpan: 1,
                colSpan:1,
            },
            // {
            //     headerKey: 'Indirect (%)',
            //     field: 'latestTimeseriesValues.charges.indirect_portfolio_costs',
            //     type: 'number',
            //     precision: 2,
            //     emptyPlaceholder: "0.00",
            //     isCSV: true,
            //     tooltip: safe(() => disclaimers["tooltip_indirect_portfolio_transaction_costs"][0]["disclaimers"][0], tooltipDefault),
            //     headerRowSpan: 1,
            //     className: tabStyles.numberColumn,
            //     headerClassName: tabStyles.columnRight, 
            // },
            {
                headerKey: 'Performance fee (%)',
                field: 'latestTimeseriesValues.charges.performance_fee',
                type: 'number',
                precision: 2,
                emptyPlaceholder: "0.00",
                isCSV: false,
                explicitHide: true,
                tooltip: safe(() => disclaimers["tooltip_performance_fee"][0]["disclaimers"][0], tooltipDefault),
                headerRowSpan: 1,
                className: tabStyles.numberColumn,
                headerClassName: tabStyles.columnRight
            },
            {
                headerKey: 'Watchlist',
                type: 'component',
                viewRestriction: 'table',
                headerRowSpan: 1,
                component: <WatchlistButton appParams={ appParams } watchlist={ watchlist } editWatchlist={ editWatchlist }></WatchlistButton>,
                getPropsFn: (row, groupedRow) => {
                    return {
                        fundName: groupedRow.display,
                        fundIdentifier: groupedRow.fund.clientCode,
                        isin: row.clientCode
                    };
                },
                displayLimitation: "web",
                headerClassName: tabStyles.watchListColumn
            }
        ];

        if (csvDownload) {
            return filterColumnsCSV(columns, isPPL);
        }

        return removeKeyWhenFalse(columns, "tooltip");
    }

    render() {
        let { funds, toggleFund, toggleAllFunds, isLoading, groupedRows, toggleShareClass, toggleShareClassPerformance, appParams, disclaimers, infiniteScroll, execInfiniteScroll } = this.props;
        const isPPL = appParams.productrange === "PPL";

        return (
            <div className={ styles.tabCharges }>
                <ExplorerTabContent {...this.props} isPPL={ isPPL } columns={ this.getColumns(isPPL) } />
                <FundExplorerFooter {...this.props} />
                { !isPrint(appParams) && <Disclaimer appParams={ appParams } disclaimer={ disclaimers["fund_charges_disclaimer"] } /> }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/components/FundExplorerTabs/FundExplorerChargesTab.tsx